import React, { useEffect } from "react";
import ReactTable from "react-table";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Close from "@material-ui/icons/Close";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import DialogTitle from "@material-ui/core/DialogTitle";

import { filterCaseInsensitive, reactTableHelper } from "../../../scripts/util";

import styles from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import { useSelector } from "react-redux";

import withTimer from "../../../components/Timer/withTimer";

import ImmigrationContainer from "./ImmigrationContainer";

import ReactGA from "react-ga";

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ImmigrationTable = ({
  match: {
    params: { id },
  },
}) => {
  const classes = useStyles();

  const [openModal, setOpenModal] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);

  const immigrations = useSelector((state) => state.immigration.immigrations);

  const [currentImmigration, setCurrentImmigration] = React.useState({});
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    setData(immigrations);
    if (!openModal) {
      setCurrentImmigration({});
      setIsEdit(false);
    }
  }, [immigrations, openModal]);

  useEffect(() => {
    if (id !== "undefined" && id > 0 && data.length > 0) {
      const found = data.find((d) => d.id == id);
      if (found) {
        setCurrentImmigration(found);
        setIsEdit(true);
        setOpenModal(true);
      }
    }
  }, [id, data]);

  const columns = [
    {
      Header: "ID",
      accessor: "id",
      width: 70,
    },
    {
      Header: "Email",
      accessor: "email",
    },
    {
      Header: "FirstName",
      accessor: "givenName",
    },
    {
      Header: "LastName",
      accessor: "familyName",
    },
    {
      Header: "Passport #",
      accessor: "passportNumber",
    },
    {
      Header: "Country of Passport",
      accessor: "countryOfPassport",
      headerStyle: { textAlign: "left" },
    },
  ];

  function getTrProps(state, rowInfo) {
    if (rowInfo && rowInfo.row) {
      return {
        onClick: (e) => {
          e.preventDefault();
          setCurrentImmigration(rowInfo.row._original);
          setOpenModal(true);
          setIsEdit(true);
          ReactGA.event({
            category: "Immigration",
            action: "View Immigration",
          });
        },
      };
    } else {
      return {};
    }
  }

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <Button
              onClick={() => {
                setOpenModal(true);
              }}
              color="primary"
            >
              Add Immigration Profile
            </Button>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem>
                <br></br>
              </GridItem>
            </GridContainer>
            <ReactTable
              pageSizeOptions={[25, 50, 100]}
              data={data}
              filterable
              resizable={true}
              getTrProps={getTrProps}
              columns={columns}
              defaultPageSize={25}
              showPaginationBottom={true}
              className="-striped -highlight"
              defaultFilterMethod={filterCaseInsensitive}
            >
              {(state, makeTable, instance) => {
                return reactTableHelper(state, makeTable, instance);
              }}
            </ReactTable>
          </CardBody>
        </Card>
      </GridItem>
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal + " " + classes.modalXL,
        }}
        open={openModal}
        disableScrollLock={true}
        TransitionComponent={Transition}
        onClose={() => setOpenModal(false)}
        aria-labelledby="classic-modal-slide-title"
        aria-describedby="classic-modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setOpenModal(false)}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h3 className={classes.modalTitle}>
            {isEdit
              ? "Update Immigration Profile"
              : "Create Immigration Profile"}
          </h3>
        </DialogTitle>
        <DialogContent
          id="classic-modal-slide-description"
          style={{
            textAlign: "left",
          }}
        >
          <ImmigrationContainer
            open={openModal}
            setOpen={setOpenModal}
            editData={currentImmigration}
            isEdit={isEdit}
            style={{
              marginBottom: "20px",
            }}
          />
        </DialogContent>
      </Dialog>
    </GridContainer>
  );
};

export default withTimer(ImmigrationTable);
